// LogoUpload.tsx
import { useState } from 'react';
import { Button, Form, Toast, ToastContainer } from 'react-bootstrap';
import api from '../../../utils/axios';

export default function LogoUpload({ clientId, onUploaded }: { clientId: number; onUploaded?: (url:string)=>void; }) {
  const [file, setFile] = useState<File|null>(null);
  const [preview, setPreview] = useState<string|undefined>();
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [uploadSuccessMessage, setUploadSuccessMessage] = useState('');

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const f = e.target.files?.[0] || null;
    setFile(f || null);
    setPreview(f ? URL.createObjectURL(f) : undefined);
  };

  const submitUpload = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!file) {
      console.error('No file selected for upload.');
      return;
    }
    try {
      const fd = new FormData();
      fd.append('file', file);
      const { data } = await api.post(`/clients/${clientId}/logo`, fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      onUploaded?.(data.url);
      console.log('Upload successful:', data);
      setUploadSuccessMessage(`${file.name} wurde erfolgreich hochgeladen.`);
      setUploadSuccess(true);
      setFile(null);
      setPreview(undefined);
    } catch (error) {
      console.error('Upload failed:', error);
    }
  };

  return (
    <>
      <Form.Group controlId="logoFile">
        <Form.Label>Client logo (.png, .jpg, .svg—max 2MB)</Form.Label>
        <Form.Control type="file" accept=".png,.jpg,.jpeg,.svg,.webp" onChange={onChange} />
      </Form.Group>
      {preview && <img src={preview} alt="Preview" style={{ maxHeight: 80, marginTop: 8 }} />}
      <div className="mt-2">
        <Button type="submit" disabled={!file} onClick={submitUpload}>
          Upload
        </Button>
      </div>
      <ToastContainer position="top-end" className="p-3">
        <Toast show={uploadSuccess} onClose={() => setUploadSuccess(false)} delay={3000} autohide>
          <Toast.Header>
            <strong className="me-auto">Upload erfolgreich</strong>
          </Toast.Header>
          <Toast.Body>{uploadSuccessMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  );
}
